import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
}
/**
 * BST Styled Form Label element to use input form controls
 * @param Props
 */
export const FormLabel = ({ children }: Props) => {
  return (
    <div className="form-label">{children}</div>
  );
};
